import type { Options } from '@sentry/core'

/** What the browser and the server SDK are both given. */
export const sharedSentryOptions = {
  // Sentry 11 collects users, cookies and bodies unless told not to; this keeps what 10 sent.
  dataCollection: { userInfo: false, cookies: false, httpBodies: [] },
  // Transactions, as on 10: span streaming, 11's default, is a change of its own.
  traceLifecycle: 'static',
} satisfies Partial<Options>
